const BATTERY_ID_TYPE = {
  CHARGE_SPOT_PB_ID: 'chargeSpotPbId',
  SERIAL: 'serial'
}

const BATTERY_WRITE_SOURCE = {
  SERVER_SAVE_WORK: 'serverSaveWork',
  TRIGGER_MIRROR_FROM_CHARGE_SPOT_PB_ID: 'triggerMirrorFromChargeSpotPbId',
  TRIGGER_WORK_SPOTJOBS: 'triggerWorkSpotJobs',
  MIGRATION_BATCH: 'migrationBatch',
  CLIENT_REGISTER: 'clientRegister',
  CLIENT_LIST_SYNC: 'clientListSync',
  CLIENT_RETURN_STATUS_NONE: 'clientReturnStatusNone',
  CLIENT_MANUAL_UPDATE: 'clientManualUpdate',
  USABLE_BATTERY_SHIPPING: 'usableBatteryShipping',
  USABLE_BATTERY_SHOP_RETURN: 'usableBatteryShopReturn'
}

const BATTERY_SYNC_SOURCE = {
  CHARGE_SPOT_PB_ID_MIRROR: 'chargeSpotPbIdMirror',
  SERIAL_MIRROR: 'serialMirror',
  MIGRATION_BATCH: 'migrationBatch'
}

const BATTERY_READ_PREFERENCE = BATTERY_ID_TYPE.SERIAL

function sanitizeBatterySerial(value) {
  if (typeof value !== 'string') return null
  const serial = value.trim()
  if (!serial || serial === 'no data' || serial.includes('/')) {
    return null
  }
  return serial
}

function inferBatteryIdType(data, docId) {
  if (data?.batteryIdType) return data.batteryIdType

  const serial = sanitizeBatterySerial(data?.serial)
  if (serial && docId === serial) {
    return BATTERY_ID_TYPE.SERIAL
  }

  if (data?.pbId && docId === data.pbId) {
    return BATTERY_ID_TYPE.CHARGE_SPOT_PB_ID
  }

  if (serial && data?.pbId && data.pbId !== serial) {
    return BATTERY_ID_TYPE.CHARGE_SPOT_PB_ID
  }

  return BATTERY_ID_TYPE.CHARGE_SPOT_PB_ID
}

function resolveBatteryWriteSource(data, batteryIdType) {
  if (data?.batteryWriteSource) return data.batteryWriteSource
  if (batteryIdType === BATTERY_ID_TYPE.SERIAL) {
    return BATTERY_WRITE_SOURCE.TRIGGER_WORK_SPOTJOBS
  }
  return BATTERY_WRITE_SOURCE.SERVER_SAVE_WORK
}

function getBatteryIdentityKey(data, docId = data?.id) {
  const serial = sanitizeBatterySerial(data?.serial)
  if (serial) {
    return `serial:${serial}`
  }

  const legacyId = data?.pbId || docId
  if (!legacyId) return null
  return `legacy:${legacyId}`
}

function getBatteryReadRank(data, docId = data?.id) {
  if (!data) return -1

  const batteryIdType = inferBatteryIdType(data, docId)
  const hasResolvedSerial = Boolean(sanitizeBatterySerial(data?.serial))

  if (BATTERY_READ_PREFERENCE === BATTERY_ID_TYPE.SERIAL) {
    if (batteryIdType === BATTERY_ID_TYPE.SERIAL) return 2
    if (!hasResolvedSerial) return 1
    return 0
  }

  if (batteryIdType === BATTERY_ID_TYPE.CHARGE_SPOT_PB_ID) return 2
  if (!data?.pbId) return 1
  return 0
}

function selectReadableBatteryDocs(batteries = []) {
  const groupedBatteries = new Map()

  batteries.forEach((battery) => {
    if (!battery) return
    const key =
      getBatteryIdentityKey(battery, battery.id) || `doc:${battery.id || ''}`
    const group = groupedBatteries.get(key) || []
    group.push(battery)
    groupedBatteries.set(key, group)
  })

  return [...groupedBatteries.values()]
    .map(
      (group) =>
        group
          .slice()
          .sort(
            (left, right) =>
              getBatteryReadRank(right, right.id) -
              getBatteryReadRank(left, left.id)
          )[0]
    )
    .filter(Boolean)
}

function shouldReadBatteryDoc(data) {
  if (!data) return false

  return getBatteryReadRank(data, data.id) >= 0
}

module.exports = {
  BATTERY_ID_TYPE,
  BATTERY_WRITE_SOURCE,
  BATTERY_SYNC_SOURCE,
  BATTERY_READ_PREFERENCE,
  sanitizeBatterySerial,
  inferBatteryIdType,
  resolveBatteryWriteSource,
  getBatteryIdentityKey,
  getBatteryReadRank,
  selectReadableBatteryDocs,
  shouldReadBatteryDoc
}
